import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { MediaStore } from "../../store";

export const useGetMediaCategories = () => {
  const dispatch = useDispatch();
  return useCallback(
    (tag: boolean) => dispatch(MediaStore.Actions.getMediaCategories(tag)),
    [dispatch]
  );
};
